<template>
  <v-main>

  
  <section class="hero-section"  style="margin-top: 64px;">
    <div class="hero-overlay">
      <div class="search-widget mt-0">
        <div class="service-tabs d-flex flex-wrap justify-center">
          <button v-for="tab in serviceTabs" :key="tab.id" class="service-tab"
            :class="{ active: currentVertical === tab.id }" :data-vertical="tab.id" @click="switchVertical(tab.id)">
            <span class="material-icons">{{ tab.icon }}</span>
            <span>{{ tab.label }}</span>
          </button>
        </div>

        <v-form id="unified-form" class="search-form vertical-form" :class="{ active: true }"
          @submit.prevent="NewCheckAvilability">
          <div v-if="unifiedForm.tripType == 1 || unifiedForm.tripType == 2 || unifiedForm.tripType == 3">
            <Outstationform v-model="unifiedForm" :pickupSuggestions="pickupSuggestions"
              :dropSuggestions="dropSuggestions" :pickupLoading="pickupLoading"
              @fetchPickupSuggestions="fetchPickupSuggestions" @fetchDropSuggestions="fetchDropSuggestions"
              @pickupSelected="onPickupSelected" @dropSelected="onDropSelected" @dateSelected="onDateSelected" />
          </div>

          <!-- AIRPORT -->
          <div v-if="unifiedForm.tripType == 4">
            <AirportForm v-model="unifiedForm" :pickupSuggestions="pickupSuggestions" :dropSuggestions="dropSuggestions"
              :pickupLoading="pickupLoading" @fetchPickupSuggestions="fetchPickupSuggestions"
              @fetchDropSuggestions="fetchDropSuggestions" @pickupSelected="onPickupSelected"
              @dropSelected="onDropSelected" />
          </div>

          <!-- RENTAL -->
          <div
            v-if="unifiedForm.tripType != 1 && unifiedForm.tripType != 2 && unifiedForm.tripType != 3 && unifiedForm.tripType != 4">
            <RentalForm v-model="unifiedForm" :pickupSuggestions="pickupSuggestions" :dropSuggestions="dropSuggestions"
              :pickupLoading="pickupLoading" @fetchPickupSuggestions="fetchPickupSuggestions"
              @fetchDropSuggestions="fetchDropSuggestions" @pickupSelected="onPickupSelected"
              @dropSelected="onDropSelected" />
          </div>

          <v-btn type="submit" class="search-button mt-4" color="#1976D2" block>
            <span> Get Rides </span>
          </v-btn>
        </v-form>
      </div>
    </div>
  </section>
  
  <!-- Login Popup -->
  <div v-if="showLoginPopup" class="login-popup-overlay">
    <LoginPopup @close="showLoginPopup = false" @login-success="handleLoginSuccess" />
  </div>
  
  <HomeContent></HomeContent>
</v-main>
</template>


<script>
// import axios from "axios";
import Outstationform from "./Outstationform.vue";
import AirportForm from "./AirportForm.vue";
import RentalForm from "./RentalForm.vue";
import HomeContent from "./HomeContent.vue";
import LoginPopup from "./LoginPopup.vue";

export default {
  name: "UnifiedSearchForm",
  components: { Outstationform, AirportForm, RentalForm, HomeContent, LoginPopup },

  data() {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    return {
      menuDate: false,
      menuDateAirport: false,
      menuDateRental: false,
      currentVertical: "outstation",
      isMultiCityEnabled: false,
      pickupLoading: false,
      pickupSuggestions: [],
      dropSuggestions: [],
      maxSegments: 10,
      multiCitySegments: [],
      showLoginPopup: false,
      unifiedForm: {
        tripType: "1",
        cabType: '1, 2, 3, 5, 6, 72, 73, 74',
        exclude_aggregators: ['1','4'],
        referenceId: "ref_" + Math.random().toString(36).substr(2, 9),
        startDate: new Date().toISOString().split('T')[0],
        startTime: "10:00:00",
        returnDate: null,
        service_type: "from_airport",
        returnTime: null,
        sourceLat: null,
        sourceLong: null,
        sourceName: null,
        sourceAddress: null,
        destinationLat: null,
        destinationLong: null,
        destinationName: "",
        destinationCityName: "",
        destinationAddress: "",
        isBookNow: false,
        destinationStateName: "",
        duration: 1, // rental only
        km: 10, // rental only
        user_id: 0,
        sourceCityName: "",
        sourceStateName: "",
        cities: [],

        // cities: [], // ✅ sirf ye rakha, segments ko yaha map karenge
      },
      currentLat: null,
      currentLong: null,
      packages: ["4hrs/40kms", "8hrs/80kms", "12hrs/120kms"],
      terminals: [],
      serviceTabs: [
        { id: "outstation", label: "OUTSTATION", icon: "map" },
        { id: "airport", label: "AIRPORT", icon: "flight" },
        { id: "rental", label: "RENTAL", icon: "schedule" },
      ],
    };
  },

  computed: {
    formattedStartDate() {
      return this.formatDisplayDate(this.unifiedForm.startDate);
    },
    formattedReturnDate() {
      return this.formatDisplayDate(this.unifiedForm.returnDate);
    },
  },

  mounted() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.currentLat = position.coords.latitude;
          this.currentLong = position.coords.longitude;
          this.reverseGeocode(position.coords.latitude, position.coords.longitude)
        },
        (error) => {
          fetch("http://ip-api.com/json")
            .then(res => res.json())
            .then(data => {
              this.currentLat = data.lat;
              this.currentLong = data.lon;
              this.reverseGeocode(data.lat, data.lon)
            })
          console.warn("User denied location ❌", error)
        }
      )
    } else {
      console.warn("Geolocation not supported in this browser")
    }
    const ignoreResizeObserverError = (event) => {
      if (event.message === "ResizeObserver loop completed with undelivered notifications.") {
        event.stopImmediatePropagation()
      }
    }

    window.addEventListener("error", ignoreResizeObserverError)
    this.toggleMultiCityMode();
    
    // Check if we need to scroll to a specific section
    if (this.$route.query.scrollTo) {
      this.$nextTick(() => {
        this.scrollToSection(this.$route.query.scrollTo);
      });
    }
  },
  watch: {
    'unifiedForm.service_type': function (newVal) {
      if (newVal == "to_airport" || newVal == "from_airport") {
        this.fetchAirportSuggestions();
      }
    },
    'unifiedForm.tripType': function (newVal) {
      if (newVal) {
        this.unifiedForm = {
          ...this.unifiedForm,
          cities: [
            {
              startTime: this.unifiedForm.startTime,
              sourceAddress: this.unifiedForm.sourceAddress,
              sourceName: this.unifiedForm.sourceName,
              sourceCityName: this.unifiedForm.sourceCityName,
              sourceStateName: this.unifiedForm.sourceStateName,
              sourceLat: this.unifiedForm.sourceLat,
              sourceLong: this.unifiedForm.sourceLong,
            },
          ]
        }
      }
    },
    currentVertical: function (newVal) {
      if (newVal == 'airport') {
        this.fetchAirportSuggestions();
      }
    },
    '$route.query.scrollTo': function (newSection) {
      if (newSection) {
        this.$nextTick(() => {
          this.scrollToSection(newSection);
        });
      }
    }
  },
  methods: {
    async reverseGeocode(lat, long) {
      const response = await fetch(
        `https://api.olamaps.io/places/v1/reverse-geocode?latlng=${lat},${long}&api_key=4Iqe4NDsH1uxOnmUNHtBluas3wdf4lcIrsRvE36q&components=country:IN`
      );
      const data = await response.json();

      if (data && data.results && data.results[0]) {
        const place = data.results[0];
        this.unifiedForm.sourceName = place.formatted_address;
        this.unifiedForm.sourceAddress = place.formatted_address;
        this.unifiedForm.sourceLat = place.geometry.location.lat;
        this.unifiedForm.sourceLong = place.geometry.location.lng;
        this.unifiedForm.sourceCityName = place.address_components.find((component) => component.types.includes("locality")).long_name;
        this.unifiedForm.sourceStateName = place.address_components.find((component) => component.types.includes("administrative_area_level_1")).long_name;
      }
    },
    async fetchPickupSuggestions(val) {
      this.pickupLoading = true;
      // Call Ola Maps API
      const response = await fetch(`https://api.olamaps.io/places/v1/autocomplete?input=${val}&api_key=4Iqe4NDsH1uxOnmUNHtBluas3wdf4lcIrsRvE36q&components=country:IN`);
      const data = await response.json();
      this.pickupSuggestions = data.predictions || [];
      this.pickupLoading = false;
    },
    async fetchAirportSuggestions() {
      const response = await fetch(`https://api.olamaps.io/places/v1/autocomplete?input=Airport&location=${this.currentLat},${this.currentLong}&api_key=4Iqe4NDsH1uxOnmUNHtBluas3wdf4lcIrsRvE36q&components=country:IN&radius=150000`);
      const data = await response.json();
      if (this.unifiedForm.service_type === "from_airport") {
        this.pickupSuggestions = data.predictions || [];
        this.unifiedForm.destinationAddress = '';
        this.unifiedForm.destinationName = '';
        const firstAirport = this.pickupSuggestions.find(
          suggestion => suggestion.types.includes("airport")
        );

        this.onPickupSelected(firstAirport);
      } else {
        this.dropSuggestions = data.predictions || [];
        this.unifiedForm.sourceAddress = '';
        this.unifiedForm.sourceName = '';
        const dropAirport = this.dropSuggestions.find(
          suggestion => suggestion.types.includes("airport")
        );
        this.onDropSelected(dropAirport);
      }
    },
    async fetchDropSuggestions(val) {
      this.dropLoading = true;
      const response = await fetch(`https://api.olamaps.io/places/v1/autocomplete?input=${val}&api_key=4Iqe4NDsH1uxOnmUNHtBluas3wdf4lcIrsRvE36q&components=country:IN`);
      const data = await response.json();
      this.dropSuggestions = data.predictions || [];
      this.dropLoading = false;
    },
    onPickupSelected(val) {
      if (val === undefined || val === null || val === "") return
      let city = val.terms[val.terms.length - 2].value;
      let sourceCityName = null;
      let sourceStateName = null;
      if (!/\d/.test(city)) {
        sourceCityName = val.terms[val.terms.length - 3].value
      } else {
        sourceCityName = val.terms[val.terms.length - 4].value
      }
      if (!/\d/.test(city)) {
        sourceStateName = val.terms[val.terms.length - 2].value
      } else {
        sourceStateName = val.terms[val.terms.length - 3].value
      }
      if (this.unifiedForm.tripType != 3) {
        this.unifiedForm = {
          ...this.unifiedForm,
          sourceAddress: val.description,
          sourceName: val.description,
          sourceLat: val.geometry.location.lat,
          sourceLong: val.geometry.location.lng,
          sourceCityName: sourceCityName,
          sourceStateName: sourceStateName,
        }
      } else {
        this.unifiedForm = {
          ...this.unifiedForm,
          cities: [
            {
              startDate: this.unifiedForm.startDate,
              startTime: this.unifiedForm.startTime,
              sourceAddress: val.description,
              sourceName: val.description,
              sourceCityName: sourceCityName,
              sourceStateName: sourceStateName,
              sourceLat: val.geometry.location.lat,
              sourceLong: val.geometry.location.lng,
            },
          ]
        }
      }
      this.$nextTick(() => {
        document.activeElement.blur();
      });

    },
    onDropSelected(val) {
      if (val === undefined || val === null || val === "") return
      let city = val.terms[val.terms.length - 2].value;
      let destinationCityName = null;
      let destinationStateName = null;
      if (!/\d/.test(city) && !val.terms[val.terms.length - 3].value.toLowerCase().includes("city")) {
        destinationCityName = val.terms[val.terms.length - 3].value
      } else {
        destinationCityName = val.terms[val.terms.length - 4].value
      }
      if (!/\d/.test(city)) {
        destinationStateName = val.terms[val.terms.length - 2].value
      } else {
        destinationStateName = val.terms[val.terms.length - 3].value
      }
      if (this.unifiedForm.tripType != 3) {
        this.unifiedForm = {
          ...this.unifiedForm,
          destinationAddress: val.description,
          destinationName: val.description,
          destinationLat: val.geometry.location.lat,
          destinationLong: val.geometry.location.lng,
          destinationCityName: destinationCityName,
          destinationStateName: destinationStateName
        }
      } else {
        if (this.unifiedForm.cities[0]?.destinationAddress == null || this.unifiedForm.cities[0]?.destinationAddress == undefined) {
          this.unifiedForm.cities[this.unifiedForm.cities.length - 1] = {
            ...this.unifiedForm.cities[this.unifiedForm.cities.length - 1],
            destinationAddress: val.description,
            destinationName: val.description,
            destinationLat: val.geometry.location.lat,
            destinationLong: val.geometry.location.lng,
            destinationCityName: destinationCityName,
            destinationStateName: destinationStateName
          }
        } else {
          this.unifiedForm.cities.push({
            startDate: this.unifiedForm.startDate,
            startTime: this.unifiedForm.startTime,
            destinationAddress: val.description,
            destinationName: val.description,
            destinationLat: val.geometry.location.lat,
            destinationLong: val.geometry.location.lng,
            destinationCityName: destinationCityName,
            destinationStateName: destinationStateName
          })
        }
      }
        this.$nextTick(() => {
        document.activeElement.blur();
      });

    },
    onDateSelected(val) {
      this.menuDate = false
      if (val) {
        // Format to YYYY-MM-DD
        const d = new Date(val)
        const yyyy = d.getFullYear()
        const mm = String(d.getMonth() + 1).padStart(2, '0')
        const dd = String(d.getDate()).padStart(2, '0')
        this.formattedOutstationDate = `${yyyy}-${mm}-${dd}`
        if (this.unifiedForm.tripType != 3) {
          this.unifiedForm.startDate = this.formattedOutstationDate
        } else {
          this.unifiedForm.cities[this.unifiedForm.cities.length - 1].startDate = this.formattedOutstationDate
        }
      }
    },
    removeCity(index) {
      this.unifiedForm.cities.splice(index, 1);
    },

    formatDisplayDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const options = { day: "2-digit", month: "short", year: "numeric" };
      return d.toLocaleDateString("en-GB", options);
    },

    switchVertical(vertical) {
      this.currentVertical = vertical;
      this.unifiedForm = {
        ...this.unifiedForm,
        sourceAddress: "",
        sourceName: "",
        destinationAddress: "",
        destinationName: "",
      };

      if (vertical === "outstation") this.unifiedForm.tripType = "1";
      if (vertical === "airport") this.unifiedForm.tripType = "4";
      if (vertical === "rental") this.unifiedForm.tripType = "5";

      if (vertical !== "outstation") {
        this.isMultiCityEnabled = false;
      }
    },

    toggleMultiCityMode() {
      if (this.isMultiCityEnabled) {
        this.unifiedForm.tripType = "3";
      } else {
        this.unifiedForm.tripType = "1";
      }
    },

    async NewCheckAvilability() {
      let payload = { ...this.unifiedForm };
      // single trip validation
      if (
        (!payload.sourceName ||
        !payload.destinationName ||
        !payload.startDate) && payload.tripType != 3
      ) {
        console.log('Please fill all required fields')
        return;
      }
      const queryString = encodeURIComponent(JSON.stringify(payload))

      this.$router.push({
        name: "SearchListing",
        query: {
          data: queryString
        },
      });

      // try {
      //   await axios.post(
      //     "/new_check_availabilities",
      //     payload
      //   );
      //         this.$router.push({
      //     name: "searchlisting",
      //     query: {
      //       source: payload.sourceName,
      //       destination: payload.destinationName,
      //       startDate: payload.startDate,
      //       tripType: payload.tripType,
      //     },
      //   });
      //   this.showToast("Booking submitted successfully!", "success");
      // } catch (err) {
      //   console.error("API Error:", err);
      //   this.showToast("Failed to submit booking. Please try again.", "error");
      // }
    },

    // async NewCheckAvilability() {
    //   let hasErrors = false;
    //   let errorMessage = "";
    //   let payload = { ...this.unifiedForm };

    //   if (this.unifiedForm.tripType === 3) {
    //     // ✅ Multi-City payload build
    //     for (let i = 0; i < this.multiCitySegments.length; i++) {
    //       const seg = this.multiCitySegments[i];
    //       if (!seg.sourceName || !seg.destinationName || !seg.startDate || !seg.startTime) {
    //         errorMessage = `Please fill all fields for Segment ${i + 1}`;
    //         hasErrors = true;
    //         break;
    //       }
    //     }
    //     if (!hasErrors) {
    //       payload.cities = this.multiCitySegments.map((seg) => ({
    //         startDate: seg.startDate,
    //         startTime: seg.startTime + ":00",
    //         sourceName: seg.sourceName,
    //         sourceAddress: seg.sourceName,
    //         destinationName: seg.destinationName,
    //         destinationAddress: seg.destinationName,
    //       }));
    //     }
    //   } else {
    //     // ✅ One Way / Round Trip / Airport / Rental validation
    //     if (!this.unifiedForm.sourceName || !this.unifiedForm.destinationName || !this.unifiedForm.startDate) {
    //       errorMessage = "Please fill all required fields";
    //       hasErrors = true;
    //     }
    //   }

    //   if (hasErrors) {
    //     this.showToast(errorMessage, "error");
    //     return;
    //   }

    //   try {
    //     const response = await axios.post(
    //       "https://backend.choosecabs.com/api/new_check_availabilities",
    //       payload
    //     );
    //     console.log("API Response:", response.data);
    //     this.showToast("Booking submitted successfully!", "success");
    //   } catch (err) {
    //     console.error("API Error:", err);
    //     this.showToast("Failed to submit booking. Please try again.", "error");
    //   }
    // },

    decreaseDuration() {
      if (this.unifiedForm.duration > 1) {
        this.unifiedForm.duration -= 1;
        this.unifiedForm.km = this.unifiedForm.duration * 10;
      }
    },

    increaseDuration() {
      if (this.unifiedForm.duration < 12) {
        this.unifiedForm.duration += 1;
        this.unifiedForm.km = this.unifiedForm.duration * 10;
      }
    },

    onStartDateChange(date) {
      this.$nextTick(() => {
        this.unifiedForm.startDate = this.formatDateForPayload(date);
        this.menuDate = false;
      });
    },
    
    scrollToSection(sectionId) {
      // Add a small delay to ensure page has loaded before scrolling
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          // For "about" section, use a larger offset to account for hero section
          const headerOffset = sectionId === 'about' ? 400 : 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 200);
    }

  },
};
</script>

<style>
.custom-list .v-list-item-title {
  font-size: 13px !important;
  white-space: normal !important;
  margin-top: 20px;
  word-break: break-word;
}

.v-autocomplete .v-field__input {
  font-size: 13px !important;
}

.duration-selector {
  padding: 16px;
  background: #f5f7fa;
  border-radius: 8px;
  margin-bottom: 16px;
}

.duration-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
}

.duration-input span {
  font-size: 16px;
  font-weight: 500;
  color: #333;
}

.search-button {
  background-color: #1976d2 !important;
  color: white !important;
  width: 100%;
  padding: 12px;
  font-weight: 600;
  text-transform: none !important;
  /* text-transform: uppercase; */
}

.duration-input {
  display: flex;
  align-items: center;
  gap: 12px;
}

.duration-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 500;
}
</style>

<style scoped>
@import url("https://fonts.googleapis.com/icon?family=Material+Icons");
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700&family=Roboto:wght@400;500;600&display=swap");


body {
  margin: 0;
  padding: 0;
  min-height: 100vh;
  background-image: url("@/assets/pratham.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: "Roboto", sans-serif;
}


.hero-section {
  position: relative;
  width: 100%;
  min-height: 400px;
  background-image: url("@/assets/pratham.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.hero-overlay {
  width: 100%;
}

.search-widget {
  max-width: 1250px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.form-wrapper {
  display: block;
  width: 100%;
}

.radio-group-side-by-side {
  display: flex;
  gap: 24px;
  align-items: center;
}

/* Multi-city wrapper */
.multi-city-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background: #f5f7fa;
  border-radius: 8px;
  border: 1px solid #ddd;
  position: relative;
}

/* From / To / Date / Time inputs */
.multi-city-row .v-autocomplete,
.multi-city-row .v-text-field {
  flex: 1 1 200px;
}

/* Remove button */
.multi-city-row button {
  background: #e53935;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 6px 10px;
  cursor: pointer;
  font-weight: bold;
  align-self: center;
}

.multi-city-row button:hover {
  background: #d32f2f;
}

/* Add City button */
div[v-if="unifiedForm.tripType === 3"]>button[type="button"] {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #1976d2;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 8px;
  font-weight: 500;
}

div[v-if="unifiedForm.tripType === 3"]>button[type="button"]:hover {
  background: #1565c0;
}

/* Icons inside inputs */
.v-autocomplete .v-input__prepend-inner .v-icon,
.v-text-field .v-input__prepend-inner .v-icon {
  color: #005886;
}

/* Labels inside inputs (optional if you want floating labels) */
.input-label {
  font-size: 12px;
  color: #555;
  display: block;
  margin-top: 4px;
}

/* Responsive */
@media (max-width: 768px) {
  .multi-city-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
